import { Loader } from '@mantine/core';
import type { ContainerStatus } from '@xver/apis/v1/kufer/containers/model';

import { Avatar } from '../../../../../components/Atoms';

const LOADER_COLOR_BY_STATUS: Partial<Record<ContainerStatus, string>> = {
    pending: '#a3a3a3',
    building: '#fbbf24',
    deploying: '#60a5fa',
};

interface ContainerAvatarProps {
    name: string;
    status: ContainerStatus;
}

export default function ContainerAvatar({ name, status }: ContainerAvatarProps) {
    const loaderColor = LOADER_COLOR_BY_STATUS[status];

    if (loaderColor) {
        return (
            <div className="w-12 h-12 rounded-md flex justify-center items-center bg-page border-[0.5px] border-line overflow-hidden">
                <Loader type="oval" color={loaderColor} size={26} />
            </div>
        );
    }

    return (
        <div className={status === 'stopped' || status === 'failed' ? 'opacity-50' : ''}>
            <Avatar value={name} size="48" />
        </div>
    );
}
